import type { Ref } from "vue";

interface UseMediaQueryOptions {
  serverFallback?: boolean | (() => boolean);
  shared?: boolean | string;
}

export function useMediaQuery(query: string, options: UseMediaQueryOptions = {}): Ref<boolean> {
  const { serverFallback = false, shared = false } = options;
  const initial = (): boolean => (typeof serverFallback === "function" ? serverFallback() : serverFallback);

  const stateKey = typeof shared === "string" ? shared : `mq:${query}`;
  const matches = shared ? useState<boolean>(stateKey, initial) : ref(initial());

  onMounted(() => {
    const mq = window.matchMedia(query);
    matches.value = mq.matches;
    const onChange = (e: MediaQueryListEvent) => {
      matches.value = e.matches;
    };
    mq.addEventListener("change", onChange);
    onBeforeUnmount(() => {
      mq.removeEventListener("change", onChange);
    });
  });

  return matches;
}
